import React from 'react';

import SkeletonLoading, { SkeletonProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const Skeleton: React.FC<SkeletonProps> = ({
  baseColor,
  borderRadius,
  circle,
  className,
  containerClassName,
  containerTestId,
  count,
  customHighlightBackground,
  direction,
  duration,
  enableAnimation,
  height,
  highlightColor,
  inline,
  style,
  width,
  wrapper,
}) => (
  <SkeletonLoading
    baseColor={baseColor}
    borderRadius={borderRadius}
    circle={circle}
    className={className}
    containerClassName={containerClassName}
    containerTestId={containerTestId}
    count={count}
    customHighlightBackground={customHighlightBackground}
    direction={direction}
    duration={duration}
    enableAnimation={enableAnimation}
    height={height}
    highlightColor={highlightColor}
    inline={inline}
    style={style}
    width={width}
    wrapper={wrapper}
  />
);
